if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.tempEvt = null;
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.form = this.querySelector('form');
      this.syncVariantIdInputs();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      // Cart refresh for Rebuy widgets is now handled by dentis-cart-sync.js
    }

    getFormId() {
      return this.form && this.form.getAttribute('id');
    }

    getExternalBundleEngineInputs() {
      const formId = this.getFormId();
      if (!formId) return [];

      return Array.from(document.querySelectorAll('[data-be-id-input][form], [data-be-prop-input][form], [data-be-color-prop-input][form], [data-be-duo-prop-input][form], [data-be-skip-prop-input][form]'))
        .filter((input) => input.getAttribute('form') === formId && !input.disabled && input.name);
    }

    getExternalBundleEngineIdInput() {
      const inputs = this.getExternalBundleEngineInputs();

      for (const input of inputs) {
        if (input.hasAttribute('data-be-id-input') && input.value) {
          return input;
        }
      }

      return null;
    }

    syncVariantIdInputs() {
      const nativeIdInput = this.form && this.form.querySelector('[name=id]');
      if (!nativeIdInput) return;

      const externalBundleEngineIdInput = this.getExternalBundleEngineIdInput();
      nativeIdInput.disabled = Boolean(externalBundleEngineIdInput);
    }

    appendExternalBundleEngineInputs(formData) {
      this.getExternalBundleEngineInputs().forEach((input) => {
        if (input.hasAttribute('data-be-id-input')) {
          formData.set(input.name, input.value);
          return;
        }

        formData.append(input.name, input.value);
      });
    }

    buildBundleEngineJsonBody(formData) {
      const rawVariantId = formData.get('id');
      const rawQuantity = formData.get('quantity');
      const variantId = Number(rawVariantId);
      const quantity = Number(rawQuantity || 1);
      const item = {
        id: Number.isFinite(variantId) ? variantId : rawVariantId,
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
      };
      const properties = {};

      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (!match || value == null || value === '') return;
        properties[match[1]] = value;
      });

      if (Object.keys(properties).length) {
        item.properties = properties;
      }

      return { items: [item] };
    }

    getCartAddUrl(useBundleEngineJsonBody) {
      if (!useBundleEngineJsonBody) return routes.cart_add_url;
      return routes.cart_add_url.endsWith('.js') ? routes.cart_add_url : `${routes.cart_add_url}.js`;
    }

    onSubmitHandler(evt, internal = false) {
      if (!internal) evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      this.syncVariantIdInputs();
      const hasBundleEngineInputs = this.getExternalBundleEngineInputs().length > 0;
      const formData = new FormData(this.form);
      this.appendExternalBundleEngineInputs(formData);
      let bundleEngineJsonBody = null;
      if (hasBundleEngineInputs) {
        bundleEngineJsonBody = this.buildBundleEngineJsonBody(formData);
      } else {
        delete config.headers['Content-Type'];
      }

      if (this.cart) {
        const sections = this.cart.getSectionsToRender().map((section) => section.id);
        if (bundleEngineJsonBody) {
          bundleEngineJsonBody.sections = sections;
          bundleEngineJsonBody.sections_url = window.location.pathname;
        } else {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = bundleEngineJsonBody ? JSON.stringify(bundleEngineJsonBody) : formData;

      fetch(this.getCartAddUrl(Boolean(bundleEngineJsonBody)), config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  this.cart.renderContents(response)
                });
              }, {once: true});
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            this.tempEvt = null;
          });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
